/**
 * @module Utilities/Request
 * @desc Request helper funtions
 */

import config from 'config';

import type { RequestAction } from '../request.d';

import { queryStringify } from './query-stringify';

const {
  bff: { baseUrl },
} = config;

export function urlResolver({ endpoint = '', payload, url, method }: RequestAction) {
  const hasPayload = !!payload;
  const path = url ? new URL(url) : new URL(endpoint, baseUrl);

  if (!hasPayload) {
    return path.href;
  }

  const payloadGuard = payload as Record<string, unknown>;

  const queryString = queryStringify(payloadGuard);

  if (method !== 'POST' && queryString.length) {
    if (path.search.length) {
      path.search = `${path.search}&${queryString}`;
    } else {
      path.search = `?${queryString}`;
    }
  }

  return path.href;
}
